export const mutations = {
  SET_WILDCARD(state, wildcard) {
    state.wildcard = wildcard;
  },
  SET_METADATA(state, metadata) {
    state.metadata = metadata;
  },
  SET_SEARCH_RESULTS(state, data = []) {
    state.searchResult = data.map((el) => {
      return {
        ...el,
        link: this.$urlBuilder('preview', {
          id: el.id,
          canonizedName: el.canonizedName,
          type: el.idType
        })
      };
    });
  },
  SET_TOTAL_RESULTS(state, data = []) {
    state.total_results = data;
  },
  SET_TOTAL_RESULTS_BY_DIMENSION(state, data) {
    state.totalResultsDimensions = data;
  },
  SET_SEARCHING(state, status) {
    state.searching = status;
  },
  SET_TOTAL_PAGES(state, data = []) {
    state.totalPages = data;
  },
  SET_CURRENT_PAGE(state, data = []) {
    state.currentPage = data;
  },
  SET_SEARCH_TITLE(state, title = '') {
    state.searchTitle = title;
  },
  SET_SEARCH_DESCRIPTION(state, description = '') {
    state.searchDescription = description;
  },
  SET_RELATED_TAGS(state, tags = []) {
    tags = tags ? tags : [];
    state.relatedTags = tags;
  },
  SET_NICHES_BY_RELATIONS(state, data) {
    state.nichesByRelationsResult = data;
  },
  TOGGLE_FILTERS_VISIBILITY(state) {
    state.showFilters = !state.showFilters;
  },
  SET_FILTERS_VISIBILITY(state, data) {
    state.showFilters = data;
  },
  SET_MULTIPLE_SEARCH_RESULTS(state, data = {}) {
    const { result, name } = data;
    const resultProcessed = result.map((el) => {
      return {
        ...el,
        link: this.$urlBuilder('preview', {
          id: el.id,
          canonizedName: el.canonizedName,
          type: el.idType
        })
      };
    });

    state.multipleSearchResult = { ...state.multipleSearchResult, [name]: resultProcessed };
  },
  SET_SILENT_SEARCH(state, data) {
    state.silentSearch = data;
  }
};

export const getters = {
  nichesResult(state) {
    const data = state.nichesByRelationsResult;
    return data ? data : [];
  },
  getSearchTitle(state) {
    return state.searchTitle;
  },
  getSearchDescription(state) {
    return state.searchDescription;
  },
  getSearchRelatedTags(state) {
    return state.relatedTags.filter((el) => el.hasLink == undefined || el.hasLink);
  },
  getCurrentPage(state) {
    return state.currentPage;
  },
  getMultipleSearchResult: (state) => (name) => {
    return name && state.multipleSearchResult[name] ? state.multipleSearchResult[name] : [];
  },
  isSearching(state) {
    return state.searching;
  },
  isLastSearchPage(state) {
    return state.currentPage == state.totalPages;
  },
  getTotalResultsDimensions(state) {
    return state.totalResultsDimensions;
  },
  getImageFirstResult(state) {
    return state.searchResult.length ? state.searchResult[0].image : '';
  },
  getSilentSearch(state) {
    return state.silentSearch;
  }
};

export const actions = {
  async MAKE_SEARCH({ commit, rootGetters, dispatch }, data) {
    let requestData = {};
    const searchAmount = this.$g('SEARCH_AMOUNT');
    commit('searchBar/CLEAR_BAR_OPEN', {}, { root: true });
    if (!data.sort) {
      commit('searchBar/SET_ACTUAL_SEARCH', data.criteria, { root: true });
      dispatch('dimensions/ACTUAL_DIMENSION', data.dimension, { root: true });
      requestData.dimension = rootGetters['dimensions/getDimensionIdByPath'](data.dimension);
      requestData.criteria = data.criteria;
    } else {
      requestData.sort = data.sort;
    }
    requestData.page = data.page ? data.page : 1;
    requestData.perPage = data.perPage ? data.perPage : searchAmount;
    requestData.url = 'search';
    const experience = data.experience;
    const config = experience ? { headers: { Experience: experience } } : {};
    var response = null;
    var results = [];
    var totalResults = 0;
    var totalPages = 0;
    var currentPage = 0;
    var searchTitle = 'Browse this vexelent contents!';
    var searchDescription = 'Browse all of our vexelent contents.';
    var relatedTags = [];
    var nichesByRelationsResult = [];
    commit('SET_SEARCHING', true);
    try {
      response = await this.$axios.post('search/', requestData, config);
      var responseData = response.data.data;
      if (!response.error) {
        const { wildcard, metadata } = responseData;
        results = responseData.results ? responseData.results : [];
        const otherDimensions = responseData.otherDimensions ? responseData.otherDimensions : [];
        results = !Array.isArray(results) ? [results] : results;
        totalResults = parseInt(responseData.total ? responseData.total : 0);
        totalPages = parseInt(
          responseData ? Math.ceil(parseInt(responseData.total) / responseData.perPage) : 0
        );
        currentPage = responseData.page;
        searchTitle = responseData.metadata.h1[0];
        searchDescription = responseData.metadata.h2[0];
        relatedTags = responseData.relateds ? responseData.relateds : [];
        nichesByRelationsResult = responseData.nichesRecomend;

        commit('SET_WILDCARD', wildcard);
        commit('SET_METADATA', metadata);
        commit('SET_SEARCH_RESULTS', results);
        commit('SET_TOTAL_RESULTS_BY_DIMENSION', otherDimensions);
        commit('SET_TOTAL_RESULTS', totalResults);
        commit('SET_TOTAL_PAGES', totalPages);
        commit('SET_CURRENT_PAGE', currentPage);
        commit('SET_SEARCH_TITLE', searchTitle);
        commit('SET_SEARCH_DESCRIPTION', searchDescription);
        commit('SET_RELATED_TAGS', relatedTags);
        commit('SET_NICHES_BY_RELATIONS', nichesByRelationsResult);

        dispatch('vectors/ADD_LISTING', results, { root: true });
        const resultsIds = results.map((el) => el.id);
        await dispatch('user/LOAD_LIKED_VECTORS', resultsIds, { root: true });
      } else {
        console.error('Search | MAKE_SEARCH 1:', responseData);
      }
    } catch (error) {
      console.error('Search | MAKE_SEARCH 2:', error);
    }
    commit('SET_SEARCHING', false);
  },
  async MAKE_SIMPLE_SEARCH({ commit, getters, rootGetters, dispatch }, data) {
    let requestData = {};
    commit('searchBar/CLEAR_BAR_OPEN', {}, { root: true });
    if (data.enableSort) {
      requestData.sort = data.sort;
      requestData.experience = data.experience;
    } else {
      requestData.dimension = rootGetters['dimensions/getDimensionIdByPath'](data.dimension);
      requestData.criteria = data.criteria;
    }
    const name = `${data.dimension}_${data.criteria}`;
    const multipleSearchResult = getters['getMultipleSearchResult'](name);
    if (!multipleSearchResult.length) {
      requestData.perPage = data.perPage ? data.perPage : 20;
      requestData.page = 1;
      var response = null;
      var results = [];
      var dataResults = {};
      commit('SET_SEARCHING', true);
      try {
        response = await this.$axios.post('search/', requestData);
        var responseData = response.data.data;
        if (!response.error) {
          results = responseData.results ? responseData.results : [];
          dataResults.result = !Array.isArray(results) ? [results] : results;
          dataResults.name = name;

          commit('SET_MULTIPLE_SEARCH_RESULTS', dataResults);

          const resultsIds = results.map((el) => el.id);
          await dispatch('user/LOAD_LIKED_VECTORS', resultsIds, { root: true });
        } else {
          console.error('Search | MAKE_SIMPLE_SEARCH 1:', responseData);
        }
      } catch (error) {
        console.error('Search | MAKE_SIMPLE_SEARCH 2:', error);
      }
    }

    commit('SET_SEARCHING', false);
  },
  async CLEAN_SEARCH({ commit }) {
    commit('searchBar/SET_ACTUAL_SEARCH', '', { root: true });
    commit('SET_WILDCARD', false);
    commit('SET_METADATA', null);
    commit('SET_SEARCH_RESULTS', []);
    commit('SET_TOTAL_RESULTS_BY_DIMENSION', []);
    commit('SET_TOTAL_RESULTS', 0);
    commit('SET_TOTAL_PAGES', 0);
    commit('SET_CURRENT_PAGE', 0);
    commit('SET_SEARCH_TITLE', 'Browse this vexelent contents!');
    commit('SET_SEARCH_DESCRIPTION', 'Browse all of our vexelent contents.');
    commit('SET_RELATED_TAGS', []);
  }
};

export const state = () => ({
  showFilters: true,
  searching: true,
  searchResult: [],
  multipleSearchResult: {},
  wildcard: false,
  metadata: null,
  nichesByRelationsResult: [],
  total_results: 0,
  totalResultsDimensions: [],
  totalPages: 0,
  currentPage: 0,
  searchTitle: 'Browse this vexelent contents!',
  searchDescription: 'Browse all of our vexelent contents.',
  relatedTags: [],
  silentSearch: false
});
